import { render } from "./MitarbeiterAccordion.vue?vue&type=template&id=6c56bf02&scoped=true"
import script from "./MitarbeiterAccordion.vue?vue&type=script&lang=js"
export * from "./MitarbeiterAccordion.vue?vue&type=script&lang=js"

import "./MitarbeiterAccordion.vue?vue&type=style&index=0&id=6c56bf02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c56bf02"]])

export default __exports__